import React from "react";
import axios from 'axios';

import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import { checkingDriverStatus, setAadhaar, setAepsAmount, setAepsCashWithDrwalReq, setAepsMobile, setAepsRequest, setAepsResponse, setAepsSection, setAmount3, setBiometricDta, setBiometricDtaCaptureStatus, setCaptureUrl, setCurrentTimeStamp, setDeviceInfoUrl, setFullName, setMobile, setMoneyTransferSurChargeAmount3, setMoneyTransferTotalAmount3, setOrderId3, setReadyDeviceName, showCreateOrderResponse3, storeAepsReqBeforeBalanceEnuiry } from "../../redux/aeps/aeps.action";
import { Link } from "react-router-dom";
import { toHaveDisplayValue } from "@testing-library/jest-dom/dist/matchers";
import tokenErrorHandler from "../tokenErrorHandler";
import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import 'bootstrap-css-only/css/bootstrap.min.css';
// import 'mdbreact/dist/css/mdb.css';
import './aepscomp.css';
import { setSelectedBankName } from "../../redux/misc-data/misc-data.action";
import biometryPaySprint from "./biometry-paysprint2";
const httpClient = axios.create();
class AEPSBalanceEnquiry extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            amount: '',
            amountErrrMsg: '',
            aePsActionType: '',
            aePsActionErrMsg: '',
            deviceConnectStatus: 'LOADING',
            mobile: '',
            mobileErrorMsg: '',
            adhaarNo: '',
            adhaarErrMsg: '',
            searchableBankList: [],
            selectedBankName: '',
            selectedBankId: '',

            bankDetails: [],
            ifscCode: '',
            bankErrMsg: '',
            cashWithdrawlPricingValue: '',
            amountErrrMsg: '',
            amount: '',
            cashWithdrawlPricingErr: ''
        }
    }



    componentDidMount() {
        this.setState({
            mobileErrorMsg: '',
            amountErrrMsg: '',
            adhaarErrMsg: '',
            aePsActionErrMsg: '',
            bankErrMsg: ''
        })

        // this.loadBankDetails();

    }
    componentWillUnmount() {
    }

    showAepsForm = (e) => {
        e.preventDefault();
        store.dispatch(setAepsSection('aepsForm'));
    }

    backToAepsPage = (event) => {
        event.preventDefault();
        store.dispatch(setAepsSection('aepsForm'));
    }

    enterAmount = (e) => {
        e.preventDefault();
        this.setState({
            amountErrrMsg: '',
            amount: e.target.value
        })
    }

    selectAmount = (e, amount) => {
        e.preventDefault();
        this.setState({
            amountErrrMsg: '',
            amount: amount
        })

    }

    calculatePricing() {

        this.setState({
            displayErrorMsg: '',
            cashWithdrawlPricingErr: ''
        })
        store.dispatch(setMoneyTransferTotalAmount3(''));
        store.dispatch(setMoneyTransferSurChargeAmount3(''));
        store.dispatch(showCreateOrderResponse3(''));
        store.dispatch(setOrderId3(''));
        store.dispatch(setAmount3(''));

        const header = {
            msgType: "CALCULATE_PRICING",
            service: "PRICING",
            // dstService:"CUSTOM_SERVICE",
            channel: "ADMIN",
            requesterId: this.props.clientRequesterId,
            requestId: uuidv4(),//filled by the 3rd party requester
            time: moment().utc(),
            traceId: uuidv4(),
        }

        var pricingUrl = '/api/v1/pricing/calculate';



        const pricingReq = {
            header: header,
            entityId: this.props.agentInfo.id,
            entityType: "RETAILER",
            productTree:
            {
                serviceCode: "BANKING",
                categoryCode: 'AEPS',
                productCode: 'CASHOUT',
                // "categoryCode": "PAYOUT",
                // "productCode": "PAYSPRINT"
            },
            txnAmount: parseFloat(this.state.amount).toFixed(2)

        }
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        console.log('pricing req:' + JSON.stringify(pricingReq));

        httpClient.post(pricingUrl, pricingReq, {
            timeout: 180 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {
            this.setState({
                progressStatus: false,
                calculatePricingFiledLock: true
            })

            console.log('pricing response' + JSON.stringify(response.data));
            if (response.data.response.msg == 'SUCCESS') {

                console.log('pricing service response:' + JSON.stringify(response.data));
                store.dispatch(setMoneyTransferTotalAmount3(this.state.amount));
                store.dispatch(setMoneyTransferSurChargeAmount3(response.data.pricingAmount));
                store.dispatch(showCreateOrderResponse3(''));
                store.dispatch(setOrderId3(''));
                store.dispatch(setAmount3(''));
                this.setState({
                    cashWithdrawlPricingValue: response.data.pricingAmount
                })

            } else {
                this.setState({
                    cashWithdrawlPricingErr: response.data.response.displayMsg
                })

            }
        }).catch(error => {

            this.setState({
                progressStatus: false,
                orderServiceErrMsg: error.message
            })

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }
        })
    }

    calculatePricingForCashWithdrawl = (event) => {
        event.preventDefault();
        store.dispatch(checkingDriverStatus(''));
        store.dispatch(setBiometricDtaCaptureStatus(''));
        store.dispatch(setBiometricDta(''));
        var isPricingOk = this.validateBeforeCashWithdrawlPricing();
        if (isPricingOk) {

            //pricing call
            this.calculatePricing();
        }

    }


    validateBeforeCashWithdrawlPricing() {
        if (this.state.amount == '') {
            this.setState({
                amountErrrMsg: 'Please enter valid amount'
            })
            return false;
        } else {
            return true;
        }
    }

    unlockAmountEdit = (event) => {
        event.preventDefault();
        this.setState({
            cashWithdrawlPricingValue: ''
        })
    }

    captureFingerPrint = () => {
        this.setState({
            orderServiceErrMsg: ''
        })
        var validateAepsValue = true;
        if (validateAepsValue == true) {
            store.dispatch(setCaptureUrl(''))
            store.dispatch(setDeviceInfoUrl(''))
            store.dispatch(setReadyDeviceName(''))
            store.dispatch(checkingDriverStatus(''))

            store.dispatch(setBiometricDta(''));
            store.dispatch(setAepsRequest(''))
            store.dispatch(setCurrentTimeStamp(''))
            store.dispatch(setBiometricDtaCaptureStatus(''));

            console.log('calling capturefingerprint');

            biometryPaySprint.captureFingerPrint(this.props.captureUrl, this.props.deviceInfoUrl);
        }



    }

    aepsAction = (event) => {
        event.preventDefault();

        store.dispatch(setAepsResponse(''))
        store.dispatch(setAepsRequest(''))
        store.dispatch(setSelectedBankName(''))
        store.dispatch(setCurrentTimeStamp(''))

        this.setState({
            progress: 'loading',
            orderServiceErrMsg: ''
        })
        var url = '/api/v1/aeps/order/create';

        var header = {
            msgType: "CREATE_ORDER",
            service: "AEPS",
            src: 'aeps',
            dst: 'aeps',
            channel: "WHITELABEL",
            requesterId: this.props.clientRequesterId,
            requestId: uuidv4(),
            time: moment().utc(),
        }

        var txn = this.props.aepsReqBeforeBalanceEnuiry.transaction;

        var transaction = {
            mobile: txn.mobile,
            customerId: txn.customerId,
            amount: this.state.amount,
            operator: txn.operator,
            category: 'AEPS_CASHOUT'
        }

        var optional = new Map();
        var btoaxmlDta = atob(this.props.aepsBiometricDta);

        optional.set('BIOMETRIC',
            btoaxmlDta
        );

        var agentId = '';

        if (process.env.REACT_APP_ENV == 'UAT') {
            agentId = this.props.agentInfo.id
        }
        if (process.env.REACT_APP_ENV == 'PROD') {
            agentId = this.props.agentInfo.id
        }

        var request = {
            header: header,
            device: this.props.deviceInfo,
            agentId: agentId,
            validated: true,
            transaction: transaction,
            optional: Object.fromEntries(optional),
        }

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        store.dispatch(setAepsCashWithDrwalReq(request));

        store.dispatch(setAepsResponse(''))
        store.dispatch(setAepsRequest(''))
        store.dispatch(setSelectedBankName(this.state.selectedBankName))
        store.dispatch(setFullName(this.props.aepsFullName))
        // store.dispatch(setAadhaar(this.state.aadhaar))
        store.dispatch(setMobile(this.props.aepsMobile))
        store.dispatch(setCurrentTimeStamp(moment().format('DD-MM-YYYY HH:mm:ss')))

        var goToAepsCashWithdrawllDetails = document.getElementById('goToAepsCashWithdrawllDetails');
        goToAepsCashWithdrawllDetails.click();




    }
    render() {



        return (
            <div class="col-12 col-lg-7 col-xl-8">
                <div class="card-b" id="rightdiv">
                    <div id="aepsministmtdetail">
                        <div class="head">
                            <div class="hright">
                                <button class="close btn" data-toggle="tooltip" title="Close"
                                    onClick={this.showAepsForm}></button>
                            </div>
                            <h3>Balance Enquiry Details</h3>
                            <Link to='/aeps-transfer'>
                                <button id='aepsTransfer' hidden={true}></button>
                            </Link>
                            <Link to='/aeps-cashwithdrawl'>
                                <button id='goToAepsCashWithdrawllDetails' hidden={true}></button>
                            </Link>

                        </div>

                        <div class="reviewboxbanance">

                        </div>
                        <div class="reviewcard">
                            <div class="status">
                                <h3 class="success">Balance view successfully!</h3>
                            </div>
                            <hr />
                            <div class="leftreview">
                                <img src="images/bank-logo.png" alt="bank" />
                                <h5>{this.props.aepsFullName.toUpperCase()}</h5>
                                <p>{this.props.selectedBankName}</p>
                            </div>

                            <div class="rightreview">
                                <h5>Aadhaar No.: {this.props.aepsAadhaar.substring(0, 4) + 'XXXXXXXX'}</h5>
                                <p>Mobile No.: {this.props.aepsMobile}</p>
                            </div>

                            <hr />

                            <div class="tnramount">
                                <p>Amount:</p>
                                <h5>₹ {parseFloat(this.props.aepsResponse.balance).toFixed(2)}</h5>
                            </div>


                            <hr />

                            <div class="leftreview">
                                <h5>RRN. No.: {this.props.aepsResponse.bankId}</h5>
                                <p>Date: {moment().format('DD-MM-YYYY')}</p>
                            </div>

                            <div class="balanceview">

                                <p>Available Balance</p>
                                <h5>₹ {parseFloat(this.props.aepsResponse.balance).toFixed(2)}</h5>
                            </div>


                        </div>

                        <div class="col-12 col-sm-4">

                            <div class="form-floating mb-3 mt-3 input-group amtmrgn">
                                <input type="number" id="amt" class="form-control"
                                    placeholder="Enter Amount" name="amount"
                                    value={this.state.amount}
                                    onChange={this.enterAmount}
                                    readOnly={this.state.cashWithdrawlPricingValue != ''
                                        && true}
                                    required
                                />
                                <label for="amt">Amount</label>
                                {this.state.cashWithdrawlPricingValue != '' &&
                                    <button class="edtamt1" type="button" onClick={this.unlockAmountEdit}
                                        data-bs-toggle="tooltip" title="Edit amount"></button>
                                }
                            </div>
                        </div>





                        <div class="col-12 col-sm-6">

                            <div class="amtbtn">
                                <button type="button" class="lbbtn1" onClick={e => this.selectAmount(e, 100)}
                                    disabled={this.state.cashWithdrawlPricingValue != '' && true}
                                >₹100</button>
                                <button type="button" class="lbbtn1" onClick={e => this.selectAmount(e, 500)}
                                    disabled={this.state.cashWithdrawlPricingValue != '' && true}
                                >₹500</button>
                                <button type="button" class="lbbtn1" onClick={e => this.selectAmount(e, 1000)}
                                    disabled={this.state.cashWithdrawlPricingValue != '' && true}
                                >₹1000</button>
                                <button type="button" class="lbbtn1" onClick={e => this.selectAmount(e, 5000)}
                                    disabled={this.state.cashWithdrawlPricingValue != '' && true}
                                >₹5000</button>

                                <button type="button" class="lbbtn1"
                                    onClick={e => this.selectAmount(e,
                                        parseInt(this.props.aepsResponse.balance)

                                    )}
                                    disabled={this.state.cashWithdrawlPricingValue != '' && true}
                                >Select All</button>
                                {this.state.amountErrrMsg != '' &&

                                    <div class='valid-error'>
                                        {this.state.amountErrrMsg}
                                    </div>
                                }
                                {this.state.cashWithdrawlPricingErr != '' &&
                                    <div class='valid-error'>
                                        Pricing:
                                        {" " + this.state.cashWithdrawlPricingErr}
                                    </div>}
                            </div>





                        </div>
                        <div class="col-12 col-sm-6">

                            <br />
                            {
                                this.state.cashWithdrawlPricingValue != '' &&
                                // <div class="amtshow"
                                // >
                                <div class='valid-success'>
                                    <h6>Commission: ₹{parseFloat(this.state.cashWithdrawlPricingValue).toFixed(2)}</h6>
                                </div>
                                // </div>
                            }

                        </div>


                        <div class="w-100"></div>

                        <div class="col-12 col-sm-6">
                            {
                                this.state.cashWithdrawlPricingValue == '' ?
                                    <div class="col-12 col-sm-6">
                                        <button type="button" class="btn btn-primary" id="capturenow"
                                            onClick={this.calculatePricingForCashWithdrawl}>Calculate Pricing</button>
                                        {this.state.orderServiceErrMsg != ''
                                            &&
                                            <div class='valid-error'>
                                                {
                                                    this.state.orderServiceErrMsg
                                                }</div>}

                                    </div> :
                                    // this.props.checkingDriverStatus == 'READY' ?
                                    (this.props.aepsBiometricDtaCaptureStatus != 'success' ?
                                        <div class="col-12 col-sm-6">
                                            <button type="button" class="btn btn-primary" id="capturenow"
                                                onClick={this.captureFingerPrint}>Capture Fingerprint</button>
                                            {this.state.orderServiceErrMsg != ''
                                                &&
                                                <div class='valid-error'>
                                                    {
                                                        this.state.orderServiceErrMsg
                                                    }</div>}
                                            {this.props.aepsBiometricDtaCaptureStatus == 'success' &&
                                                <div class='valid-success'>
                                                    Fingerprint captured successfully
                                                </div>}
                                        </div> :
                                        <div class="col-12 col-sm-6">
                                            <button type="submit" class="btn btn-primary" id="proceedAeps"
                                                onClick={this.aepsAction}
                                                disabled={this.state.progress == 'loading' && true}
                                            >Proceed</button>
                                            {this.state.orderServiceErrMsg != ''
                                                &&
                                                <div class='valid-error'>
                                                    {
                                                        this.state.orderServiceErrMsg
                                                    }</div>}
                                            {this.state.progress == 'loading' &&
                                                <div class='valid-success'>
                                                    Please wait...</div>}
                                        </div>)

                            }
                        </div>


                        {
                            (this.props.checkingDriverStatus == 'READY' &&
                                this.props.aepsBiometricDta != '' &&
                                this.props.aepsBiometricDta != 'error') ?
                                <div class="col-12 col-sm-6">
                                    <div class="device"><i class="connect"></i> Biometric device connected and fingerprint scanned for Aadhaar authentication</div>
                                </div>
                                :
                                this.props.checkingDriverStatus == 'LOADING' ?
                                    <div class="col-12 col-sm-6">
                                        <div class="device"><i class="connect"></i> Detecting Biometric Driver status..Please wait</div>
                                    </div>
                                    :
                                    this.props.checkingDriverStatus == 'ERROR' &&
                                    <div class="col-12 col-sm-6">
                                        <div class="device"><i class="disconnect"></i> Biometric device not connected or Driver not installed!
                                            Please make sure to connect device before go to AePS page</div>
                                    </div>

                        }

                    </div>
                </div>

            </div>


        );
    }
}


const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    aepsReduce: { aepsAmount,
        aepsResponse,
        aepsReq,
        aepsSelectedBank,
        aepsFullName,
        aepsMobile,
        aepsAadhaar, aepsReqBeforeBalanceEnuiry,
        aepsBiometricDtaCaptureStatus, aepsBiometricDta, checkingDriverStatus },
    miscReduce: { phone, agentInfo, token, selectedBankName, clientRequesterId, deviceInfo }
}
) => ({
    errorMessage, loginErrorMessage, aepsAmount,
    aepsResponse,
    aepsReq,
    aepsSelectedBank,
    aepsFullName,
    aepsMobile,
    aepsAadhaar, aepsReqBeforeBalanceEnuiry,
    aepsBiometricDtaCaptureStatus, aepsBiometricDta, checkingDriverStatus,
    phone, agentInfo, token, selectedBankName, clientRequesterId, deviceInfo
});




export default connect(mapStateToProps, null)(AEPSBalanceEnquiry);
